const protectedRoute = (role) => {
  return {
    requiresAuth: true,
    requiredRole: role || undefined
  }
}
export default [
  {
    path: '/spa/a',
    component: () => import('@layouts/ApplicationDataWrapper.vue'),
    meta: protectedRoute(),
    children: [
      {
        name: 'campaigns',
        path: 'campaigns',
        component: () => import('@pages/PartnerCampaigns.vue'),
        meta: {
          title: 'Campaigns',
          breadcrumb: {
            label: 'Campaigns',
            icon: 'cell_tower',
          }
        },
      },
      {
        name: 'campaign-templates',
        path: 'campaign-templates',
        component: () => import('@pages/CampaignTemplates.vue'),
        meta: { title: 'Campaign Templates', breadcrumb: { label: 'Campaign Templates', icon: 'cell_tower' } }
      },
      {
        name: 'partner-campaign-builder',
        path: 'partner-campaigns/:campaignId/campaign-builder',
        component: () => import('@pages/campaigns/partner-campaign-builder.vue'),
        meta: { title: 'Partner Campaign Builder', breadcrumb: { label: 'Partner Campaign Builder', icon: 'cell_tower' } }
      },
      {
        name: 'leads',
        path: 'leads',
        component: () => import('@pages/leads.vue'),
        meta: { 
          title: 'Leads', 
          breadcrumb: {
            label: 'Leads',
            icon: 'group',
          }
        }
      },
      {
        name: 'lead',
        path: 'leads/:leadId',
        component: () => import('@pages/leads.vue'),
        meta: { title: 'Lead Details' }
      },
      {
        name: 'ad-metrics',
        path: 'ad-metrics',
        component: () => import('@pages/reports/AdMetrics.vue'),
        meta: { 
          title: 'Ad Metrics',
          breadcrumb: {
            label: 'Ad Metrics',
            icon: 'leaderboard'
          }
        }
      },
      {
        name: 'lead-metrics',
        path: 'lead-metrics',
        component: () => import('@pages/reports/LeadMetrics.vue'),
        meta: { 
          title: 'Lead Metrics',
          breadcrumb: {
            label: 'Lead Metrics',
            icon: 'leaderboard'
          }
        }
      },
      {
        name: 'user-settings',
        path: 'user-settings',
        component: () => import('@pages/user-settings.vue'),
        meta: { title: 'User Settings', breadcrumb: { label: 'User Settings', icon: 'settings' } }
      },
      {
        name: 'field-mapper',
        path: 'field-mapper',
        component: () => import('@pages/FieldMapper.vue'),
        meta: { title: 'Field Mapper' }
      },
      {
        name: 'email-sequences',
        path: 'email-sequences',
        component: () => import('@pages/emails/EmailSequences.vue'),
        meta: { 
          title: 'Email Sequences',
          breadcrumb: {
            label: 'Email Sequences',
            icon: 'handshake'
          }
        }
      },
      {
        name: 'email-sequence-details',
        path: 'email-sequences/:sequenceId',
        component: () => import('@pages/emails/EmailSequenceDetails.vue'),
        meta: { 
          title: 'Email Sequence Details',
          breadcrumb: {
            label: 'Email Sequence Details',
            icon: 'handshake'
          }
        }
      },
      {
        name: 'email-sequence-builder',
        path: 'email-sequence-builder/:sequenceId',
        component: () => import('@pages/EmailSequenceBuilder.vue'),
        meta: { title: 'Email Sequence Builder', breadcrumb: { label: 'Email Sequence Builder', icon: 'handshake' } }
      },
      {
        name: 'mdf',
        path: 'mdf',
        component: () => import('@pages/mdf/MDF.vue'),
        meta: { 
          title: 'MDF', 
          breadcrumb: {
            label: 'MDF',
            icon: 'credit_card',
          }
        }
      },
      {
        name: 'proposal-builder',
        path: 'mdf/:public_id',
        component: () => import('@pages/mdf/ActivityViewsContainer.vue'),
        props: true,
        meta: {
          title: 'MDF Activity',
          breadcrumb: {
            label: 'Activity',
            icon: 'description'
          }
        }
      }
    ],
  },
]